<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div :class="[ tab === 'contact' ? 'active' : '' ]" @click="tab = 'contact'">Contact details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">
        Options
        <span class="caret"></span>
      </button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li @click="tab = 'contact'">
          <a href="#">
            Contact details
            <i class="fa fa-check-square-o" v-if="tab === 'contact'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div v-if="isNew">
              <div class="form-group">
                <label for="ext-name" class="form-label">User login *</label>
                <input type="text" class="form-control" id="role-name" v-model="entity.userLogin" data-toggle="tooltip" :data-title="usernameTooltip" />
              </div>
              <div class="form-group">
                <label for="pw" class="form-label">Password <span>*</span></label>
                <div class="input-group">
                  <input v-if="!showPassword" type="password" class="form-control" id="pw" v-model="entity.password" data-toggle="tooltip" :data-title="passwordTooltip" />
                  <input v-if="showPassword" type="text" class="form-control" id="pw" v-model="entity.password" data-toggle="tooltip" :data-title="passwordTooltip" />
                  <span class="input-group-addon" @click="showPassword = !showPassword">
                    <i class="fa fa-eye"></i>
                  </span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="form-group">
                <label for="ext-name" class="form-label">User login</label>
                <div class="input-group">
                  <input :disabled="userLoginLocked" type="text" class="form-control" id="role-name" v-model="entity.userLogin"/>
                  <span class="input-group-addon" @click="userLoginLocked = !userLoginLocked">
                    <i class="fa fa-lock"></i>
                  </span>
                </div>
              </div>
              <div class="form-group">
                <label for="pw" class="form-label">Password</label>
                <div class="input-group">
                  <input v-if="!showPassword" :disabled="passwordLocked" type="password" class="form-control" id="pw" v-model="entity.password"/>
                  <input v-if="showPassword" :disabled="passwordLocked" type="text" class="form-control" id="pw" v-model="entity.password"/>
                  <span class="input-group-addon" @click="passwordLocked = !passwordLocked">
                    <i class="fa fa-lock"></i>
                  </span>
                  <span class="input-group-addon" @click="showPassword = !showPassword">
                    <i class="fa fa-eye"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="active" class="form-label">Active?</label>
              <div class="material-switch">
                <input id="active" type="checkbox" v-model="entity.active"/>
                <label for="active" class="label-success"></label>
              </div>
            </div>
            <div>
              <div class="form-group">
                <label for="title" class="form-label">Title</label>
                <select class="form-control" id="title" v-model="entity.person.title">
                  <option value=""></option>
                  <option value="Master">Master</option>
                  <option value="Mr">Mr</option>
                  <option value="Miss">Miss</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Ms">Ms</option>
                  <option value="Mx">Mx</option>
                </select>
              </div>
              <div class="form-group">
                <label for="fname" class="form-label">Firstname</label>
                <input type="text" class="form-control" id="fname" v-model="entity.person.firstName"/>
              </div>
              <div class="form-group">
                <label for="mname" class="form-label">Middlename</label>
                <input type="text" class="form-control" id="mname" v-model="entity.person.middleName"/>
              </div>
              <div class="form-group">
                <label for="lname" class="form-label">Lastname</label>
                <input type="text" class="form-control" id="lname" v-model="entity.person.lastName"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="pg" class="form-label">User group</label>
              <select class="form-control" id="pg" v-model="entity.userGroup">
                <option value=""></option>
                <option v-for="(opt, i) in groups" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div v-if="isSystemOptionParameterEnabled('ENABLE_MULTIPLE_USER_BRANDS')" class="form-group">
              <label for="b" class="form-label">Tariff Sets</label>
              <div class="panel panel-default">
                <div class="panel-body">
                  <ul class="list-unstyled">
                    <li v-for="(brandGroup, i) in brandGroups">
                      <div class="checkbox">
                        <label>
                          <input type="checkbox" v-model="selectedBrands[brandGroup.code]" />{{ brandGroup.name }}
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div v-else class="form-group">
              <label for="b" class="form-label">Brand</label>
              <select class="form-control" id="b" v-model="entity.brand">
                <option value=""></option>
                <option v-for="(opt, i) in brands" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="role" class="form-label">Role</label>
              <select class="form-control" id="role" v-model="entity.person.role">
                <option value=""></option>
                <option v-for="(opt, i) in roles" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label class="form-label">Party</label>
              <autocomplete
                :dataset="partySearchResults"
                title="Party"
                placeHolder="Type to search"
                :initVal="personParty"
                v-on:changing="data => partySearchText = data"
                :fnFormatText="displayParty"
                :fnSelectValue="displayParty"
                v-on:selection-made="selectPersonParty"
              />
            </div>
            <div class="form-group">
              <label for="enum" class="form-label">Employee number</label>
              <input type="text" class="form-control" id="enum" v-model="entity.person.employeeNumber"/>
            </div>
            <div class="form-group">
              <label for="pnum" class="form-label">Payroll Number</label>
              <input type="text" class="form-control" id="pnum" v-model="entity.person.payrollNumber"/>
            </div>
          </div>
        </div>
        <div v-if="tab === 'contact'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="dob" class="form-label">Date Of Birth</label>
              <date-picker :date="dob" :option="dateOption"></date-picker>
            </div>
            <!-- div class="form-group">
              <label for="retired" class="form-label">Retired?</label>
              <div class="material-switch">
                <input id="retired" type="checkbox" v-model="entity.person.retired"/>
                <label for="retired" class="label-success"></label>
              </div>
            </div -->
            <div class="form-group">
              <label for="email" class="form-label">Email</label>
              <input type="text" class="form-control" id="email" v-model="entity.person.email"/>
            </div>
            <div class="form-group">
              <label for="pemail" class="form-label">Private Email</label>
              <input type="text" class="form-control" id="pemail" v-model="entity.person.privateEmail"/>
            </div>
            <div class="form-group">
              <label for="fax" class="form-label">Fax</label>
              <input type="text" class="form-control" id="fax" v-model="entity.person.fax"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="wphone" class="form-label">Work Phone</label>
              <input type="text" class="form-control" id="wphone" v-model="entity.person.workPhone"/>
            </div>
            <div class="form-group">
              <label for="hphone" class="form-label">Home Phone</label>
              <input type="text" class="form-control" id="hphone" v-model="entity.person.homePhone"/>
            </div>
            <div class="form-group">
              <label for="mphone" class="form-label">Mobile Phone</label>
              <input type="text" class="form-control" id="mphone" v-model="entity.person.mobilePhone"/>
            </div>
            <div class="form-group">
              <label for="web" class="form-label">Website</label>
              <input type="text" class="form-control" id="web" v-model="entity.person.website"/>
            </div>
            <div class="form-group">
              <label for="skype" class="form-label">Skype</label>
              <input type="text" class="form-control" id="skype" v-model="entity.person.skype"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  import dateConfig from '../../../../../static/js/date-picker-config.json'
  import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'

  export default {
    name: 'User',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      DatePicker,
      Autocomplete
    },
    data () {
      return {
        dob: {
          time: null
        },
        dateOption: dateConfig,
        passwordLocked: true,
        showPassword: false,
        userLoginLocked: true,
        transformForUpdate: {
          systemLanguage: this.toMinus,
          brand: this.toMinus,
          userGroup: this.toMinus
        },
        newEntityScreen: 'Admin - Users',
        editEntityScreen: 'Admin - Edit/View User',
        tab: 'main',
        selectedBrands: {},
        entity: {
          id: null,
          userLogin: null,
          password: null,
          systemLanguage: null,
          brand: null,
          brands: null,
          userGroup: null,
          active: null,
          person: {
            id: null,
            title: null,
            firstName: null,
            middleName: null,
            lastName: null,
            nickName: null,
            contactType: 400,
            role: null,
            party: null,
            employeeNumber: null,
            payrollNumber: null,
            dateOfBirth: null,
            retired: false,
            email: null,
            fax: null,
            workPhone: null,
            homePhone: null,
            mobilePhone: null,
            website: null,
            skype: null
          }
        },
        entityName: 'mai-user',
        boxes: [
          {
            prop: 'userGroup',
            id: 'id'
          },
          {
            prop: 'brand',
            id: 'id'
          },
          {
            prop: this.unwrapPerson,
            id: null
          }
        ],
        usernameTooltip: 'User login must be at least 5 characters',
        passwordTooltip: 'Password must at least 8 characters, and contains lowercase character(s), uppercase character(s), special character(s) and number(s)'
      }
    },
    watch: {
      'dob.time' (newVal, oldVal) {
        if (this.entity.person.dateOfBirth !== newVal) {
          this.entity.person.dateOfBirth = newVal
        }
      },
      'entity.person.dateOfBirth' (newVal, oldVal) {
        if (this.dob.time !== newVal) {
          this.dob.time = newVal
        }
      },
      'entity.person.firstName' (newVal, oldVal) {
        this.updateNickName()
      },
      'entity.person.lastName' (newVal, oldVal) {
        this.updateNickName()
      }
    },
    computed: {
      roles () {
        return this.$store.getters['systemOption/roles']
      },
      isValid () {
        return this.entity.userLogin && this.entity.userLogin.trim().length > 4 && this.passwordValid
      },
      passwordValid () {
        return this.isUpdate && (!this.entity.password || (this.entity.password && this.entity.password.trim().length >= 8 && this.entity.password.trim().length < 70 && this.passwordHasMix)) ||
        this.isNew && (this.entity.password && this.entity.password.trim().length >= 8 && this.entity.password.trim().length < 70 && this.passwordHasMix)
      },
      passwordHasMix () {
        return true
      },
      brandGroups () {
        return this.$store.getters['systemOption/brandGroups']
      },
      groups () {
        return this.$store.getters['systemOption/userGroups']
      },
      roleExists () {
        return this.entity.hasOwnProperty('person') && this.entity.person.hasOwnProperty('role') && this.entity.person.role !== null
      },
      personParty () {
        return this.entity.hasOwnProperty('person') && this.entity.person.hasOwnProperty('party') ? this.entity.person.party : null
      },
      brands () {
        return this.getSystemOptions('BRAND')
      }
    },
    methods: {
      preSaveRoutine () {
        return new Promise((resolve, reject) => {
          this.entity.brands = this.getSelectedBrands()
          this.entity.person.role = (this.entity.person.role === '' || this.entity.person.role === null) ? -1 : this.entity.person.role
          resolve()
        })
      },
      getSelectedBrands () {
        const brands = []
        Object.entries(this.selectedBrands).forEach(([prop, value]) => {
          if (value) { brands.push(prop) }
        })
        return brands.join()
      },
      updateNickName () {
        this.entity.person.dateOfBirth = this.fromTimestamp(this.entity.person.dateOfBirth)
        this.entity.person.nickName = `${this.entity.person.firstName} ${this.entity.person.lastName}`
      },
      selectPersonParty (p) {
        this.entity.person.party = p
        this.partySearchText = ''
        this.partySearchResults = []
      },
      runCustomUnwrap () {
        if (this.roleExists) {
          this.entity.person.role = this.entity.person.role.id
        }
      },
      initData () {
        for (let prop in this.baseEntity) {
          if (prop !== 'password') {
            this.entity[prop] = this.baseEntity[prop]
          }
        }
        if (this.entity.brands) {
          this.entity.brands.split(',').forEach(brand => {
            this.selectedBrands[brand] = true
          })
        }
        this.unbox()
      },
      getBaseData () {
        return {
          id: null,
          userLogin: null,
          password: null,
          systemLanguage: null,
          brand: null,
          brands: null,
          userGroup: null,
          active: null,
          person: {
            id: null,
            title: null,
            firstName: null,
            middleName: null,
            lastName: null,
            nickName: null,
            contactType: 400,
            role: null,
            party: null,
            employeeNumber: null,
            payrollNumber: null,
            dateOfBirth: null,
            retired: false,
            email: null,
            fax: null,
            workPhone: null,
            homePhone: null,
            mobilePhone: null,
            website: null,
            skype: null
          }
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// User.vue?5d0db1d0